// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1doQq","row":"styles_row__17-zS"};